module.exports = __webpack_public_path__ + "img/photo_green_small.2adf4b15.png";